import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type Options } from 'highcharts'
import * as ChartOptions from '../components/ChartOptions'
// import { type flameReadingData } from '../services/getFlameSignaGraphDataService'

interface FlameSignalDataOptions {
  flameSignalChartOptions: Options
}

export interface flameSignalReadingDataState {
  isLoading: boolean
  errorMessage: string | null
  flameSignalReadingData: FlameSignalDataOptions | null
  httpStatus: number | null
}

// Initial state of the slice

const initialState: flameSignalReadingDataState = {
  flameSignalReadingData: {
    flameSignalChartOptions: ChartOptions.getFlameSignalDataOptions()
  },
  isLoading: false,
  errorMessage: null,
  httpStatus: null
}

// Slice to return from action
export const flameSignalDataState = createSlice({
  name: 'flameSignalData',
  initialState,
  reducers: {
    flameSignalDataLoadingAction: (state) => {
      // clear out the data whenever we reload
      return {
        flameSignalReadingData: null,
        isLoading: true,
        errorMessage: null,
        httpStatus: 0
      }
    },
    flameSignalDataUpdateAction: (state, action: PayloadAction<{ data: FlameSignalDataOptions, httpStatus: number }>) => {
      return {
        flameSignalReadingData: action.payload.data,
        isLoading: false,
        errorMessage: null,
        httpStatus: action.payload.httpStatus
      }
    },
    flameSignalDataErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        flameSignalReadingData: null,
        isLoading: false,
        errorMessage: action.payload.errorMessage,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

// Actions to export
export const {
  flameSignalDataLoadingAction,
  flameSignalDataUpdateAction,
  flameSignalDataErrorAction
} = flameSignalDataState.actions

export default flameSignalDataState.reducer
